import Spinner from '@components/_elements/Spinner/Spinner';
import SimplePointDataTableWithTitle from '@components/_shared/MultiColPointDataTableWithTitle';
import useGetInternalWidgetConfig from '@hooks/api/queries/widgets/useGetInternalWidgetConfig';
import { Typography } from '@mui/material';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';
import { WidgetTypeMultiSectionPointList } from '@src/types/Widget';

interface Props {
  selectedMpId: string;
}

function MegapackDetails(props: Props) {
  const { selectedMpId } = props;

  const {
    data: widgetConfig,
    isLoading,
    isError,
  } = useGetInternalWidgetConfig<WidgetTypeMultiSectionPointList>(
    'mpDetailsModal',
    {
      sourceDeviceId: selectedMpId,
    },
  );

  if (isLoading) {
    return <Spinner type='content-small' />;
  }
  if (isError) {
    return (
      <Typography textAlign='center' marginTop='50px'>
        <FormattedAlias id={'Error fetching widget data.'} />
      </Typography>
    );
  }

  return widgetConfig?.sections.map((sectionData, i) => (
    <SimplePointDataTableWithTitle
      key={`megapack-details-${Math.random()}`}
      sectionIndex={i}
      data={sectionData}
    />
  ));
}

export default MegapackDetails;
